import React, { Component } from "react";
import {
  Grid,
  Box,
  Button,
  TableContainer,
  FormControl,
  Menu,
  Paper,
  MenuItem,
} from "@mui/material";
import TableList from "./CustomTool/TableList";
import CtTxt from "./CustomTool/CtTxt";
import CtTxtNum from "./CustomTool/CtTxtNum";
import CtBtn from "./CustomTool/CtBtn";
import CtCmb from "./CustomTool/CtCmb";
import {
  Edit,
  Delete,
  RefreshOutlined,
  CallMissedOutgoing,
} from "@mui/icons-material";
import Progress from "./CustomTool/Progress";
import CtCheckBox from "./CustomTool/CtCheckBox";
import CtMultiLineText from "./CustomTool/CtMultiLineText";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";
import {
  fetchSales,
  fetchItemMaster,
  fetchDetailMaster,
  fetchCustomerMaster,
  apiURL,
  fetchReferenceMaster,
} from "./API";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import CtDtp from "./CustomTool/CtDtp";
import { withRouter } from "../HOC/withRouter";
import SalesItemEntry from "./SalesItemEntry";
import SalesInvoiceSelection from "./SalesInvoiceSelection";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import {
  get_YMD_from_SYS,
  isValidItem,
  applyTrimOnObjectValues,
  getRoundOff,
  getString_or_Blank4Null,
  validatedate_min_max,
  copyRowsAllCols,
  getRowData,
  isNumeric,
  getTaxNumFromStr,
  getRowColSum,
} from "../SystemUtility/SystemUtility";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import CustomerMaster from "./CustomerMaster";
import ReferenceMaster from "./ReferenceMaster";
import DetailMaster from "./DetailMaster";
import PaymentModeTable from "./PaymentModeTable";
import OrderSelection from "./OrderSelection";
import SalesEWayBill from "./SalesEWayBill";
import CtTxtAmt from "./CustomTool/CtTxtAmt";
import moment from "moment";
import OCPItemEntry from "./OCPItemEntry";

class OCPEntry extends Component {
  state = {
    Company: [],
    Customer: [],
    ShipTo: [],
    ItemNameList: [],
    StoreList: [],
    PackingList: [],
    TaxNameList: [],
    BillNoList: [],
    LedgerNameList: [],
    ReferenceList: [],
    DetailList: [],
    SalesInvoiceGeneration: "",
    CustomerStateCode: "",
    CustomerData: [],
    EWayBillData: [],
    StateList: [],
    columns: [
      { id: "Action", label: "Search", name: "Search" },
      { id: "bint_itemsrno", label: "S.N." },
      { id: "vac_storename", label: "Store Name" },
      { id: "vac_itemname", label: "Item Name" },
      { id: "vac_hsncode", label: "HSN" },
      { id: "vac_unit", label: "Packing" },
      { id: "dec_qty", label: "Qty" },
      { id: "dec_rate", label: "Rate" },
      { id: "dec_basicamt", label: "Basic Amt" },
      { id: "dec_disper", label: "Dis (%)" },
      { id: "dec_disamt", label: "Dis Amt" },
      { id: "dec_taxable", label: "Taxable" },
      { id: "vac_taxname", label: "Tax" },
      { id: "dec_cgstamt", label: "CGST" },
      { id: "dec_sgstamt", label: "SGST" },
      { id: "dec_igstamt", label: "IGST" },
      { id: "dec_totalamt", label: "Total Amount" },
      { id: "vac_remark", label: "Remark" },
    ],
    actionList: [
      {
        name: "Edit",
        icon: <Edit />,
        link: "ChallanEntry:",
        actionType: "AlertResponsive",
        visiblecondition: [
          { colID: "DisableEdit", value: false, relationalOperator: "==" },
        ],
        // hide: (this.props.userPrivilege.Sales == 'R' || this.props.userPrivilege.Sales == 'W')
      },
      {
        name: "Delete",
        icon: <Delete />,
        link: "ChallanEntry:",
        actionType: "AlertResponsive",
        hide:
          this.props.userPrivilege.Sales == "R" ||
          this.props.userPrivilege.Sales == "W",
      },
    ],
    keyColumn: [
      "bint_itemsrno", //0
      "vac_itemname", //1
      "vac_hsncode", //2
      "vac_unit", //3
      "dec_qty", //4
      "dec_rate", //5
      "dec_basicamt", //6
      "dec_disper", //7
      "dec_disamt", //8
      "dec_taxable", //9
      "vac_taxname", //10
      "dec_cgstamt", //11
      "dec_sgstamt", //12
      "dec_igstamt", //13
      "dec_totalamt", //14
      "vac_remark", //15
      "vac_storename", //16
    ],

    PaymentmodeListCols: [
      "bint_acid",
      "bint_ledgercode",
      "bint_ledgeridsrno",
      "dec_opbalance",
      "vac_backgroundprocess",
      "vac_company",
      "vac_firmname",
      "vac_groupheader",
      "vac_groupname",
      "vac_gstno",
      "vac_ledgername",
    ],
    transactionType: "Remain",

    formData: {
      edit_salessrno: "",
      dtpDate: get_YMD_from_SYS(new Date()),
      dtpDueDate: "",
      cmbCompany: localStorage.getItem("CompanyName"),

      cmbOCPType: "",
      txtOCPNo: "",
      LblOCPNo: "",

      cmbCustomer: "",
      cmbShipTo: "",
      txtOtherDetail: "",
      txtDiscount: "",
      txtTaxable: "",
      txtCGST: "",
      txtSGST: "",
      txtIGST: "",
      txtGrandTotal: "",
      txtTDSAmount: "",
      txtAdvPayment: "",
      txtNetPayment: "",
      txtRoundOff: "",
      txtRemark: "",
      chkReceiptGenerated: false,
      cmbReference: "",
      dec_remainamt: "",
      txtACKno: "",
      txtACKDate: "",
      txtIRN: "",
      tblCGST: 0,
      tblSGST: 0,
      tblIGST: 0,
    },
    autoResetFormData: false,
    searchData: {
      bint_itemsrno: "",
      vac_storename: "",
      vac_itemname: "",
      vac_hsncode: "",
      vac_unit: "",
      dec_qty: "",
      dec_rate: "",
      dec_basicamt: "",
      dec_disper: "",
      dec_disamt: "",
      dec_taxable: "",
      vac_taxname: "",
      dec_cgstamt: "",
      dec_sgstamt: "",
      dec_igstamt: "",
      dec_totalamt: "",
      vac_remark: "",
    },
    searchColumns: [],
    searchRows: [],
    searchOpen: false,
    searchRowsCount: 0,
    dataLoadStatus: true,
    ARD: null,
    DRP: "",
    rows: [],
    rowsCount: 0,
    rowsPerPage: 50,
    totalBeforeTaxAmt: 0,
    totalAfterTaxAmt: 0,

    columnsOtherDetail: [
      { id: "Action", label: "" },
      { id: "vac_headingvalue", label: "Headings" },
      { id: "txtFormate", label: "" },
      {
        id: "vac_value",
        label: "Values",
        type: "CtTxt",
        CtrlProps: {
          value: "",
          width: 150,
          maxLength: 20,
          amountOnlyCondition: [
            {
              colID: "vac_calculation",
              value: "-",
              relationalOperator: "===",
              logicalOperator: "||",
            },
            {
              colID: "vac_calculation",
              value: "+",
              relationalOperator: "===",
              logicalOperator: "||",
            },
          ],
        },
      },
    ],
    rowsOtherDetail: [],
    rowsOtherDetail1: [],

    rowsCountOtherDetail: 0,
    rowsCountOtherDetail1: 0,

    rowsPerPageOtherDetail: 10,
    rowsPerPageOtherDetail1: 10,

    Displaybtn: false,

    columnsPaymentMode: [
      // { id: "Action", label: "Search", name: "Search" },
      // { id: 'bint_srno', label: 'SR NO' },
      { id: "vac_ledgername", label: "Payment Mode Ledger" },
      {
        id: "dec_amount",
        label: "Amount",
        type: "CtTxtAmt",
        CtrlProps: { value: "", width: 100, maxLength: 20 },
      },
      {
        id: "vac_chequeno",
        label: "Cheque No",
        type: "CtTxtNum",
        CtrlProps: { value: "", width: 100, maxLength: 20 },
      },
      {
        id: "vac_referenceno",
        label: "Reference No",
        type: "CtTxtNum",
        CtrlProps: { value: "", width: 100, maxLength: 20 },
      },
      {
        id: "dat_transactiondate",
        label: "Transaction Date",
        type: "CtDtp",
        CtrlProps: { value: "", maxLength: 20 },
      },
      {
        id: "vac_remark",
        label: "Remark",
        type: "CtMultiLineText",
        CtrlProps: { value: "", width: 120, maxLength: 100 },
      },
      { id: "vac_groupname", label: "Group Name", hide: true },
    ],
    rowsPaymentMode: [],
    rowsCountPaymentMode: 0,
    rowsPerPagePaymentMode: 5,
    DefaultEntrySettingList: [],
    PaymentData: [],
    PaymentmodeListCols: [
      "bint_acid",
      "bint_ledgercode",
      "bint_ledgeridsrno",
      "dec_opbalance",
      "vac_backgroundprocess",
      "vac_company",
      "vac_firmname",
      "vac_groupheader",
      "vac_groupname",
      "vac_gstno",
      "vac_ledgername",
    ],
  };

  //#region Component
  componentDidMount() {
    document.title = "RiTe Account :" + this.props.module + " Entry";
    this.props.setActiveMenu(this.props.module + "Entry");
    this.setSearchColumns();
    this.props.verifyUserID(
      this.onFormLoad,
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges
    );
  }
  //#endregion Component

  //#region handle
  handleOnChange = (e) => {
    this.setState(
      {
        formData: { ...this.state.formData, [e.target.name]: e.target.value },
      },
      () => {
        if (e.target.name === "cmbOCPType") {
          this.getProformaNo();
        } else if (e.target.name === "cmbCustomer") {
          this.getStateCodeOFCustomer();
        } else if (
          e.target.name === "txtAdvPayment" ||
          e.target.name === "txtTDSAmount"
        ) {
          this.calNetAmount();
        }
      }
    );
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
  };

  handleARDonActionClick = (row) => {};

  handleOnSearchInputChange = (e) => {};

  handleOnSearchChange = (searchOpen) => {};

  handleOnNewEntryClick = () => {
    if (this.validateChallan() === true) {
      let ARD = null;
      this.setState({ ARD }, () => {
        ARD = (
          <AlertResponsiveDialog
            labelDisagree="Close"
            // New : Sales Item Entry'
            alertMessage={
              <OCPItemEntry
                refreshSalesItemList={this.refreshSalesItemList}
                getItemList={this.getItemList}
                resetAmount={this.resetAmount}
                module={this.props.module}
                bint_acid={localStorage.getItem("acid")}
                bint_acyear={localStorage.getItem("ACY")}
                ItemNameList={this.state.ItemNameList}
                PackingList={this.state.PackingList}
                TaxNameList={this.state.TaxNameList}
                StoreList={this.state.StoreList}
                edit_salessrno={this.state.formData.edit_salessrno}
                dtpDate={this.state.formData.dtpDate}
                dtpDueDate={this.state.formData.dtpDueDate}
                cmbCompany={localStorage.getItem("CompanyName")}
                cmbOCPType={this.state.formData.cmbOCPType}
                txtOCPNo={this.state.formData.LblOCPNo}
                bint_billno={this.state.formData.txtOCPNo}
                cmbCustomer={this.state.formData.cmbCustomer}
                cmbReference={this.state.formData.cmbReference}
                CustomerStateCode={this.state.CustomerStateCode}
                CustomerData={this.state.CustomerData}
                cmbShipTo={this.state.formData.cmbShipTo}
                txtOtherDetail={this.state.formData.txtOtherDetail}
                txtDiscount={this.state.formData.txtDiscount}
                txtTaxable={this.state.formData.txtTaxable}
                txtCGST={this.state.formData.txtCGST}
                txtSGST={this.state.formData.txtSGST}
                txtIGST={this.state.formData.txtIGST}
                txtGrandTotal={this.state.formData.txtGrandTotal}
                txtTDSAmount={this.state.formData.txtTDSAmount}
                txtAdvPayment={this.state.formData.txtAdvPayment}
                txtNetPayment={this.state.formData.txtNetPayment}
                txtRoundOff={this.state.formData.txtRoundOff}
                txtRemark={this.state.formData.txtRemark}
                rowsPaymentMode={this.state.rowsPaymentMode}
                rowsOtherDetail={this.state.rowsOtherDetail}
                rowsOtherDetail1={this.state.rowsOtherDetail1}
                dec_beforetaxamt={this.state.totalBeforeTaxAmt}
                dec_aftertaxamt={this.state.totalAfterTaxAmt}
                // onSuccessfulSalesItemEntry={this.updateStateInfo}
              />
            }
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD });
      });
    }
  };

  setEwayBillARDNull = (EWayBillData) => {
    this.setState({ ARD: null, EWayBillData });
  };

  ewaybillprocess = () => {
    if (this.validateChallan() === true) {
      let ARD = null;
      this.setState({ ARD }, () => {
        ARD = (
          <AlertResponsiveDialog
            fullscreenOnly={true}
            labelDisagree="Close"
            alertMessage={
              <SalesEWayBill
                setEwayBillARDNull={this.setEwayBillARDNull}
                EWayBillData={this.state.EWayBillData}
                StateList={this.state.StateList}
                resetAmount={this.resetAmount}
                bint_acid={localStorage.getItem("acid")}
                bint_acyear={localStorage.getItem("ACY")}
                ItemNameList={this.state.ItemNameList}
                PackingList={this.state.PackingList}
                TaxNameList={this.state.TaxNameList}
                StoreList={this.state.StoreList}
                edit_salessrno={this.state.formData.edit_salessrno}
                dtpDate={this.state.formData.dtpDate}
                dtpDueDate={this.state.formData.dtpDueDate}
                cmbCompany={localStorage.getItem("CompanyName")}
                cmbOCPType={this.state.formData.cmbOCPType}
                txtOCPNo={this.state.formData.LblOCPNo}
                bint_billno={this.state.formData.txtOCPNo}
                cmbCustomer={this.state.formData.cmbCustomer}
                cmbReference={this.state.formData.cmbReference}
                CustomerStateCode={this.state.CustomerStateCode}
                CustomerData={this.state.CustomerData}
                cmbShipTo={this.state.formData.cmbShipTo}
                txtOtherDetail={this.state.formData.txtOtherDetail}
                txtDiscount={this.state.formData.txtDiscount}
                txtTaxable={this.state.formData.txtTaxable}
                txtCGST={this.state.formData.txtCGST}
                txtSGST={this.state.formData.txtSGST}
                txtIGST={this.state.formData.txtIGST}
                txtGrandTotal={this.state.formData.txtGrandTotal}
                txtTDSAmount={this.state.formData.txtTDSAmount}
                txtAdvPayment={this.state.formData.txtAdvPayment}
                txtNetPayment={this.state.formData.txtNetPayment}
                txtRoundOff={this.state.formData.txtRoundOff}
                txtRemark={this.state.formData.txtRemark}
                rowsPaymentMode={this.state.rowsPaymentMode}
                rowsOtherDetail={this.state.rowsOtherDetail}
                rowsOtherDetail1={this.state.rowsOtherDetail1}
                dec_beforetaxamt={this.state.totalBeforeTaxAmt}
                dec_aftertaxamt={this.state.totalAfterTaxAmt}
              />
            }
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD });
      });
    }
  };

  handleChangeRowsPerPageOtherDetail = (rowsPerPageOtherDetail) => {
    this.setState({ rowsPerPageOtherDetail });
  };

  handleChangeRowsPerPageOtherDetail1 = (rowsPerPageOtherDetail1) => {
    this.setState({ rowsPerPageOtherDetail1 });
  };
  handleOnNewEntryClickOtherDetail = () => {
    let ARD = null;
    this.setState({ ARD }, () => {
      ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          alertMessage={<DetailMaster />}
          defaultOpenDialog={true}
          handleOnClickNo={this.getDetailList}
        />
      );
      this.setState({ ARD });
    });
  };

  handleChangeRowsPerPagePaymentMode = (rowsPerPagePaymentMode) => {
    this.setState({ rowsPerPagePaymentMode });
  };

  handleOnRowDataChangeOtherDetail = (
    rowsOtherDetail,

    handledRowIndex,
    colID
  ) => {
    this.setState(
      {
        formData: {
          ...this.state.formData,
        },
      },
      () => {
        let totalBeforeTaxAmt = 0;
        let totalAfterTaxAmt = 0;
        let tblCGST = 0,
          tblSGST = 0,
          minustblIGST = 0,
          plustblIGST = 0;
        if (isNumeric(this.state.formData.tblCGST)) {
          tblCGST = Number(this.state.formData.tblCGST);
        }
        if (isNumeric(this.state.formData.tblSGST)) {
          tblSGST = Number(this.state.formData.tblSGST);
        }
        if (isNumeric(this.state.formData.tblIGST)) {
          minustblIGST = Number(this.state.formData.tblIGST);
          plustblIGST = Number(this.state.formData.tblIGST);
        }
        rowsOtherDetail.map((row, index) => {
          if (isNumeric(row["vac_value"])) {
            let value = Number(row["vac_value"]);
            if (row["vac_taxname"] && row["vac_calculation"] == "+") {
              totalBeforeTaxAmt += value;
              let result = this.taxCalcualte(
                row,
                "+",
                tblCGST,
                tblSGST,
                plustblIGST
              );
              tblCGST = Number(result.tblCGST);
              tblSGST = Number(result.tblSGST);
              plustblIGST = Number(result.tblIGST);
            } else if (row["vac_taxname"] && row["vac_calculation"] == "-") {
              totalBeforeTaxAmt -= value;
              let result = this.taxCalcualte(
                row,
                "-",
                tblCGST,
                tblSGST,
                minustblIGST
              );
              tblCGST = Number(result.tblCGST);
              tblSGST = Number(result.tblSGST);
              minustblIGST = Number(result.tblIGST);
            } else if (
              row["vac_calculationstyle"] == "After Tax" &&
              row["vac_calculation"] == "+"
            ) {
              totalAfterTaxAmt += value;
            } else if (
              row["vac_calculationstyle"] == "After Tax" &&
              row["vac_calculation"] == "-"
            ) {
              totalAfterTaxAmt -= value;
            }
          }
        });

        let tblIGST = Number(plustblIGST) + Number(minustblIGST);

        this.setState(
          {
            rowsOtherDetail,
            rowsCountOtherDetail: rowsOtherDetail.length,

            formData: {
              ...this.state.formData,
            },
          },
          () => {
            this.calNetAmount();
          }
        );
      }
    );
  };
  handleOnRowDataChangeOtherDetail1 = (
    rowsOtherDetail1,

    handledRowIndex,
    colID
  ) => {
    this.setState(
      {
        formData: {
          ...this.state.formData,
          tblCGST: 0,
          tblSGST: 0,
          tblIGST: 0,
        },
      },
      () => {
        let totalBeforeTaxAmt = 0;
        let totalAfterTaxAmt = 0;
        let tblCGST = 0,
          tblSGST = 0,
          minustblIGST = 0,
          plustblIGST = 0;
        if (isNumeric(this.state.formData.tblCGST)) {
          tblCGST = Number(this.state.formData.tblCGST);
        }
        if (isNumeric(this.state.formData.tblSGST)) {
          tblSGST = Number(this.state.formData.tblSGST);
        }
        if (isNumeric(this.state.formData.tblIGST)) {
          minustblIGST = Number(this.state.formData.tblIGST);
          plustblIGST = Number(this.state.formData.tblIGST);
        }
        rowsOtherDetail1.map((row, index) => {
          if (isNumeric(row["vac_value"])) {
            let value = Number(row["vac_value"]);
            if (row["vac_taxname"] && row["vac_calculation"] == "+") {
              totalBeforeTaxAmt += value;
              let result = this.taxCalcualte(
                row,
                "+",
                tblCGST,
                tblSGST,
                plustblIGST
              );
              tblCGST = Number(result.tblCGST);
              tblSGST = Number(result.tblSGST);
              plustblIGST = Number(result.tblIGST);
            } else if (row["vac_taxname"] && row["vac_calculation"] == "-") {
              totalBeforeTaxAmt -= value;
              let result = this.taxCalcualte(
                row,
                "-",
                tblCGST,
                tblSGST,
                minustblIGST
              );
              tblCGST = Number(result.tblCGST);
              tblSGST = Number(result.tblSGST);
              minustblIGST = Number(result.tblIGST);
            } else if (
              row["vac_calculationstyle"] == "After Tax" &&
              row["vac_calculation"] == "+"
            ) {
              totalAfterTaxAmt += value;
            } else if (
              row["vac_calculationstyle"] == "After Tax" &&
              row["vac_calculation"] == "-"
            ) {
              totalAfterTaxAmt -= value;
            }
          }
        });

        let tblIGST = Number(plustblIGST) + Number(minustblIGST);

        this.setState(
          {
            rowsOtherDetail1,
            rowsCountOtherDetail1: rowsOtherDetail1.length,
            totalBeforeTaxAmt,
            totalAfterTaxAmt,
            formData: {
              ...this.state.formData,
              tblCGST: Number(tblCGST),
              tblSGST: Number(tblSGST),
              tblIGST: Number(tblIGST),
              txtCGST: 0,
              txtSGST: 0,
              txtIGST: 0,
            },
          },
          () => {
            this.calNetAmount();
          }
        );
      }
    );
  };

  taxCalcualte = (row, icon, tblCGST, tblSGST, tblIGST) => {
    if (isNumeric(row["vac_value"])) {
      let value = Number(row["vac_value"]);
      if (row["vac_taxname"].length > 0) {
        const txtTaxable = value,
          TaxName = getTaxNumFromStr(row["vac_taxname"]);

        if (Number(txtTaxable) != 0 && Number(TaxName) >= 0) {
          tblCGST =
            icon == "+"
              ? tblCGST + (txtTaxable * (TaxName / 2)) / 100
              : tblCGST - (txtTaxable * (TaxName / 2)) / 100;
          tblCGST = Number(tblCGST);
          tblCGST = tblCGST.toFixed(2);
          tblSGST = tblCGST;

          if (
            this.state.CustomerStateCode !=
            localStorage.getItem("CompStateCode")
          ) {
            tblIGST = Number(tblCGST) + Number(tblSGST);
            tblCGST = 0;
            tblSGST = 0;
          }
        }
      }
    }
    return { tblCGST, tblSGST, tblIGST };

    /* this.setState(
      {
        formData: {
          ...this.state.formData,
          tblCGST: Number(tblCGST),
          tblSGST: Number(tblSGST),
          tblIGST: Number(tblIGST),
        },
      },
      () => {
        
      }
    ); */
  };

  // balnkTaxCalculate = (totalBeforeTaxAmt) => {
  //   if (totalBeforeTaxAmt == 0) {
  //     this.setState({
  //       formData: {
  //         ...this.state.formData,
  //         tblCGST: 0,
  //         tblSGST: 0,
  //         tblIGST: 0,
  //       },
  //     });
  //   }
  // };

  handleOnRowDataChangePaymentMode = (
    rowsPaymentMode,
    handledRowIndex,
    colID
  ) => {
    this.setState({
      rowsPaymentMode,
      rowsCountPaymentMode: rowsPaymentMode.length,
    });
  };

  handleOnChkChange = (e) => {
    if (this.getAdvancePaidAccessStatus()) {
      this.setState(
        {
          formData: {
            ...this.state.formData,
            [e.target.name]: e.target.checked,
          },
        },
        () => {}
      );
    } else {
      this.setState({
        formData: {
          ...this.state.formData,
          [e.target.name]: false,
        },
      });
    }
  };
  //#endregion handle

  //#region function

  getAdvancePaidAccessStatus = () => {
    return (
      this.state.rowsCount >= 1 && Number(this.state.formData.txtAdvPayment) > 0
    );
  };

  setSearchColumns = () => {};

  trimFormData = (nextFunctionCall) => {
    let formData = applyTrimOnObjectValues({
      formData: this.state.formData,
      excludeKeysArray: ["chkReceiptGenerated"],
    });
    this.setState({ formData }, () => {
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  validateChallan = () => {
    let result = false;
    if (this.state.formData.dtpDate.length <= 0) {
      this.props.toastErrorMsg("Enter Date", "dtpDate");
    } else if (
      validatedate_min_max(
        this.state.formData.dtpDate,
        "dtpDate",
        this.props.toastErrorMsg
      ) == false
    ) {
      return false;
    } else if (this.state.formData.cmbOCPType.length <= 0) {
      this.props.toastErrorMsg("Select Challan Type", "cmbOCPType");
    } else if (this.state.formData.txtOCPNo.length <= 0) {
      this.props.toastErrorMsg("Enter Challan No", "txtOCPNo");
    } else if (this.state.formData.cmbCustomer.length <= 0) {
      this.props.toastErrorMsg("Select Customer Name", "cmbCustomer");
    } else if (
      isValidItem(
        this.state.Customer,
        "vac_customer",
        this.state.formData.cmbCustomer
      ) == false
    ) {
      this.props.toastErrorMsg("Select Valid Customer Name", "cmbCustomer");
    } else if (
      this.state.formData.cmbShipTo.length > 0 &&
      isValidItem(
        this.state.ShipTo,
        "vac_customer",
        this.state.formData.cmbShipTo
      ) == false
    ) {
      this.props.toastErrorMsg("Select Valid Ship to Name", "cmbShipTo");
    } else if (
      this.state.formData.cmbReference &&
      this.state.formData.cmbReference.length > 0 &&
      isValidItem(
        this.state.ReferenceList,
        "vac_referencename",
        this.state.formData.cmbReference
      ) == false
    ) {
      this.props.toastErrorMsg("Select Valid Reference Name", "cmbReference");
    } else {
      result = true;
    }
    return result;
  };

  validateChallanItemCount = () => {
    // this.props.toastErrorMsg("validateChallanItemCount")
    let result = false;
    if (this.state.rowsCount <= 0) {
      this.props.toastErrorMsg("Enter atleast one item", "dtpDate");
    } else {
      result = true;
    }
    return result;
  };

  validatePaymentModeAmount = () => {
    let result = false,
      dec_amount = 0;
    if (
      this.getPaymentModeDataStatus &&
      this.state.rowsPaymentMode.length > 0
    ) {
      this.state.rowsPaymentMode.map((row) => {
        if (row.dec_amount != undefined) {
          dec_amount += Number(row.dec_amount);
        }
      });
    } else {
      result = true;
    }
    return result;
  };

  onFormLoad = () => {
    let dataLoadStatus = false;
    this.setState({ dataLoadStatus, autoResetFormData: false }, () => {
      let bint_acyear = 0,
        bint_acid = "",
        edit_salessrno = 0;
      if (this.props.location.state && this.props.location.state != null) {
        bint_acid = this.props.location.state.bint_acid;
        edit_salessrno = this.props.location.state.bint_salessrno;
        bint_acyear = this.props.location.state.bint_acyear;
        let reqData = {
          Op: "SalesData",
          bint_acyear,
          bint_acid,
          edit_salessrno,
          vac_userid: localStorage.getItem("logInID"),
          bint_ci: localStorage.getItem("CI"),
        };
        fetchSales(reqData)
          .then((res) => {
            this.props.updateProcessing(res.data.msgType, res.data.message);
            let Customer = res.data.CustomerList,
              ShipTo = res.data.CustomerList,
              TaxNameList = res.data.TaxList,
              ItemNameList = res.data.ItemList,
              StoreList = res.data.StoreList,
              SalesInvoiceGeneration = res.data.GeneralSettingList[0].vac_value,
              InvoiceNoList = res.data.InvoiceNoList,
              DefaultEntrySettingList = res.data.DefaultEntrySettingList,
              rowsOtherDetail = [],
              rowsOtherDetail1 = [],
              rowsCountOtherDetail = rowsOtherDetail.length,
              rowsCountOtherDetail1 = rowsOtherDetail1.length,
              rows = [],
              rowsCount = rows.length,
              rowsPaymentMode = [],
              rowsCountPaymentMode = rowsPaymentMode.length,
              LedgerNameList = [],
              DetailList = [],
              ReferenceList = res.data.ReferenceList,
              PaymentData = [],
              EWayBillData = [],
              StateList = [];
            if (res.data.SalesItemData && res.data.SalesItemData.length > 0) {
              rows = this.addActionColStatus(res.data.SalesItemData);
              rowsCount = rows.length;
            }
            if (res.data.EWayBillData) {
              EWayBillData = res.data.EWayBillData;
            }
            if (res.data.StateList) {
              StateList = res.data.StateList;
            }
            if (res.data.LedgerNameList && res.data.LedgerNameList.length > 0) {
              rowsPaymentMode = res.data.LedgerNameList;
              LedgerNameList = res.data.LedgerNameList;
              rowsCountPaymentMode = rowsPaymentMode.length;
            } /*  else {
              if (
                res.data.LedgerNameList &&
                res.data.LedgerNameList.length > 0
              ) {
                rowsPaymentMode = res.data.LedgerNameList;
                LedgerNameList = res.data.LedgerNameList;
              }
            } */
            /* if (res.data.PaymentData && res.data.PaymentData.length > 0) {
              res.data.PaymentData.map((odd) => {
                let isFound = 0;
                rowsPaymentMode.map((rod) => {
                  if (rod.vac_ledgername === odd.vac_ledgername) {
                    // rod.vac_value = odd.vac_value;
                    rod.dec_amount = odd.dec_amount;
                    rod.vac_chequeno = odd.vac_chequeno;
                    rod.vac_referenceno = odd.vac_referenceno;
                    rod.dat_transactiondate = odd.dat_transactiondate;
                    rod.vac_remark = odd.vac_remark;
                    rod.vac_groupname = odd.vac_groupname;
                    isFound++;
                  }
                });
                if (isFound === 0) {
                  rowsPaymentMode.push({
                    vac_ledgername: odd.vac_ledgername,
                    dec_amount: odd.dec_amount,
                    vac_chequeno: odd.vac_chequeno,
                    vac_referenceno: odd.vac_referenceno,
                    dat_transactiondate: odd.dat_transactiondate,
                    vac_remark: odd.vac_remark,
                    vac_groupname: odd.vac_groupname,
                    // bint_displayorderno: rowsPaymentMode.length + 1,
                  });
                }
              });
              rowsCountPaymentMode = rowsPaymentMode.length;
            } */
            if (res.data.DetailList && res.data.DetailList.length > 0) {
              rowsOtherDetail = res.data.DetailList.map((row) => {
                return {
                  ...row,
                  txtFormate:
                    row["vac_calculationstyle"] == "Before Tax"
                      ? row["vac_calculation"] +
                        (row["vac_taxname"]
                          ? "(" + row["vac_taxname"] + ")"
                          : "")
                      : row["vac_calculation"],
                };
              });
              DetailList = res.data.DetailList;
              rowsCountOtherDetail = rowsOtherDetail.length;
            }
            if (res.data.DetailList && res.data.DetailList.length > 0) {
              rowsOtherDetail1 = res.data.DetailList.map((row) => {
                return {
                  ...row,
                  txtFormate:
                    row["vac_calculationstyle"] == "Before Tax"
                      ? row["vac_calculation"] +
                        (row["vac_taxname"]
                          ? "(" + row["vac_taxname"] + ")"
                          : "")
                      : row["vac_calculation"],
                };
              });
              DetailList = res.data.DetailList;
              rowsCountOtherDetail1 = rowsOtherDetail1.length;
            }
            if (
              res.data.OtherDetailData &&
              res.data.OtherDetailData.length > 0
            ) {
              res.data.OtherDetailData.map((odd) => {
                let isFound = 0;
                rowsOtherDetail.map((rod) => {
                  if (rod.vac_headingvalue === odd.vac_headingvalue) {
                    rod.vac_value = odd.vac_value;
                    isFound++;
                  }
                });
                if (isFound === 0) {
                  rowsOtherDetail.push({
                    vac_headingvalue: odd.vac_headingvalue,
                    vac_value: odd.vac_value,
                    bint_displayorderno: rowsOtherDetail.length + 1,
                  });
                }
              });
              rowsCountOtherDetail = rowsOtherDetail.length;
            }
            if (
              res.data.OtherDetailData &&
              res.data.OtherDetailData.length > 0
            ) {
              res.data.OtherDetailData.map((odd) => {
                let isFound = 0;
                rowsOtherDetail1.map((rod) => {
                  if (rod.vac_headingvalue === odd.vac_headingvalue) {
                    rod.vac_value = odd.vac_value;
                    isFound++;
                  }
                });
                if (isFound === 0) {
                  rowsOtherDetail1.push({
                    vac_headingvalue: odd.vac_headingvalue,
                    vac_value: odd.vac_value,
                    bint_displayorderno: rowsOtherDetail1.length + 1,
                  });
                }
              });
              rowsCountOtherDetail1 = rowsOtherDetail1.length;
            }
            if (res.data.PaymentData && res.data.PaymentData.length > 0) {
              PaymentData = res.data.PaymentData;
            }
            if (res.data.OrderSelection === "true") {
              this.setState({ Displaybtn: true });
            }
            this.setState(
              {
                dataLoadStatus: true,
                Customer,
                ShipTo,
                TaxNameList,
                ItemNameList,
                BillNoList: InvoiceNoList,
                DefaultEntrySettingList,
                StoreList,
                SalesInvoiceGeneration,
                rows,
                rowsCount,
                rowsOtherDetail,
                rowsOtherDetail1,

                rowsCountOtherDetail,
                rowsCountOtherDetail1,

                rowsPaymentMode,
                rowsCountPaymentMode,
                LedgerNameList,
                DetailList,
                ReferenceList,
                PaymentData,
                totalAfterTaxAmt: res.data.SalesList[0].dec_aftertaxamt,
                totalBeforeTaxAmt: res.data.SalesList[0].dec_beforetaxamt,
                EWayBillData,
                StateList,
                formData: {
                  ...this.state.formData,
                  edit_salessrno: res.data.SalesList[0].bint_salessrno,
                  dtpDate: res.data.SalesList[0].dat_salesdate,
                  // dtpDueDate: res.data.SalesList[0].dtpDueDate,
                  cmbCompany: res.data.SalesList[0].vac_company,
                  cmbOCPType: res.data.SalesList[0].vac_billtype,
                  txtOCPNo: res.data.SalesList[0].bint_billno,
                  LblOCPNo: res.data.SalesList[0].vac_billno,

                  cmbCustomer: res.data.SalesList[0].vac_customer,
                  cmbShipTo: getString_or_Blank4Null(
                    res.data.SalesList[0].vac_customershipto
                  ),
                  txtDiscount: res.data.SalesList[0].dec_discamt,
                  txtTaxable: res.data.SalesList[0].dec_taxable,
                  txtCGST: res.data.SalesList[0].dec_cgst,
                  txtSGST: res.data.SalesList[0].dec_sgst,
                  txtIGST: res.data.SalesList[0].dec_igst,
                  txtGrandTotal: res.data.SalesList[0].dec_grtotal,
                  txtTDSAmount: res.data.SalesList[0].dec_tdsamount,
                  txtAdvPayment: res.data.SalesList[0].dec_advancepayment,
                  txtRoundOff: res.data.SalesList[0].dec_roundoff,
                  txtNetPayment: res.data.SalesList[0].dec_netpayment,
                  dec_remainamt: res.data.SalesList[0].dec_remainamt,

                  txtRemark: res.data.SalesList[0].vac_remark,
                  cmbReference: res.data.SalesList[0].vac_referencename
                    ? res.data.SalesList[0].vac_referencename
                    : "",
                  chkReceiptGenerated:
                    res.data.SalesList[0].vac_receiptgenerated == "Yes"
                      ? true
                      : false,
                  txtACKDate: res.data.SalesList[0].dat_ackdate,
                  txtACKno: res.data.SalesList[0].vac_ackno,
                  txtIRN: res.data.SalesList[0].vac_irn,
                },
              },
              () => {
                this.getStateCodeOFCustomer();
              }
            );
          })
          .catch((error) => {
            this.props.toastMsg(
              "error",
              "Unkonwn Error occured in onFormLoad. " + error
            );
          });
      } else {
        const reqData = {
          Op: "LoadSalesAllCmbDetail",
          bint_acid: localStorage.getItem("acid"),
          bint_acyear: localStorage.getItem("ACY"),
          vac_userid: localStorage.getItem("logInID"),
        };
        fetchSales(reqData)
          .then((res) => {
            dataLoadStatus = true;
            let Customer = [],
              ShipTo = [],
              TaxNameList = [],
              ItemNameList = [],
              StoreList = [],
              SalesInvoiceGeneration = [],
              InvoiceNoList = [],
              DefaultEntrySettingList = [],
              rowsOtherDetail = [],
              rowsOtherDetail1 = [],
              rowsCountOtherDetail = rowsOtherDetail.length,
              rowsCountOtherDetail1 = rowsOtherDetail1.length,
              rowsPaymentMode = [],
              rowsCountPaymentMode = rowsPaymentMode.length,
              LedgerNameList = [],
              DetailList = [],
              PaymentData = [],
              ReferenceList = [];
            if (res.data.CustomerList && res.data.CustomerList.length > 0) {
              Customer = res.data.CustomerList;
            }
            if (res.data.CustomerList && res.data.CustomerList.length > 0) {
              ShipTo = res.data.CustomerList;
            }
            if (res.data.TaxList && res.data.TaxList.length > 0) {
              TaxNameList = res.data.TaxList;
            }
            if (res.data.ItemList && res.data.ItemList.length > 0) {
              ItemNameList = res.data.ItemList;
            }
            if (res.data.StoreList && res.data.StoreList.length > 0) {
              StoreList = res.data.StoreList;
            }
            if (
              res.data.GeneralSettingList &&
              res.data.GeneralSettingList.length > 0
            ) {
              SalesInvoiceGeneration = res.data.GeneralSettingList[0].vac_value;
            }
            if (res.data.InvoiceNoList && res.data.InvoiceNoList.length > 0) {
              InvoiceNoList = res.data.InvoiceNoList;
            }
            if (
              res.data.DefaultEntrySettingList &&
              res.data.DefaultEntrySettingList.length > 0
            ) {
              DefaultEntrySettingList = res.data.DefaultEntrySettingList;
            }

            if (res.data.LedgerNameList && res.data.LedgerNameList.length > 0) {
              rowsPaymentMode = res.data.LedgerNameList;
              LedgerNameList = res.data.LedgerNameList;
              rowsCountPaymentMode = rowsPaymentMode.length;
            }
            if (res.data.DetailList && res.data.DetailList.length > 0) {
              rowsOtherDetail = res.data.DetailList.map((row) => {
                return {
                  ...row,
                  txtFormate:
                    row["vac_calculationstyle"] == "Before Tax"
                      ? row["vac_calculation"] +
                        (row["vac_taxname"]
                          ? "(" + row["vac_taxname"] + ")"
                          : "")
                      : row["vac_calculation"],
                };
              });
              DetailList = res.data.DetailList;
              rowsCountOtherDetail = rowsOtherDetail.length;
            }
            if (res.data.DetailList && res.data.DetailList.length > 0) {
              rowsOtherDetail1 = res.data.DetailList.map((row) => {
                return {
                  ...row,
                  txtFormate:
                    row["vac_calculationstyle"] == "Before Tax"
                      ? row["vac_calculation"] +
                        (row["vac_taxname"]
                          ? "(" + row["vac_taxname"] + ")"
                          : "")
                      : row["vac_calculation"],
                };
              });
              DetailList = res.data.DetailList;
              rowsCountOtherDetail1 = rowsOtherDetail1.length;
            }
            if (res.data.ReferenceList && res.data.ReferenceList.length > 0) {
              ReferenceList = res.data.ReferenceList;
            }
            if (res.data.PaymentData && res.data.PaymentData.length > 0) {
              PaymentData = res.data.PaymentData;
            }
            if (res.data.OrderSelection === "true") {
              this.setState({ Displaybtn: true });
            }
            this.setState(
              {
                dataLoadStatus,
                Customer,
                ShipTo,
                TaxNameList,
                ItemNameList,
                StoreList,
                SalesInvoiceGeneration,
                BillNoList: InvoiceNoList,
                DefaultEntrySettingList,
                LedgerNameList,
                DetailList,
                PaymentData,

                autoResetFormData: true,
                rowsOtherDetail,
                rowsOtherDetail1,

                rowsCountOtherDetail: rowsOtherDetail.length,
                rowsCountOtherDetail1: rowsOtherDetail1.length,

                rowsPaymentMode,
                rowsCountPaymentMode,
                ReferenceList,
              },
              () => {
                this.getDefaultProformaType();
              }
            );
          })
          .catch((error) => {
            console.log("Unknown error occurred in onFormLoad.", error);
          });
      }
    });
    document.getElementById("cmbCustomer").focus();
  };

  clearInfo = () => {
    this.setState(
      {
        totalAfterTaxAmt: "",
        totalBeforeTaxAmt: "",
        formData: {
          ...this.state.formData,
          edit_salessrno: "",
          dtpDate: get_YMD_from_SYS(new Date()),
          dtpDueDate: "",
          cmbCompany: localStorage.getItem("CompanyName"),

          cmbCustomer: "",
          cmbShipTo: "",
          txtOtherDetail: "",
          txtDiscount: "",
          txtTaxable: "",
          txtCGST: "",
          txtSGST: "",
          txtIGST: "",
          tblCGST: "",
          tblSGST: "",
          tblIGST: "",
          txtGrandTotal: "",
          txtTDSAmount: "",
          txtAdvPayment: "",
          txtNetPayment: "",
          txtRoundOff: "",
          txtRemark: "",
          chkReceiptGenerated: false,
          cmbReference: "",
          txtACKDate: "",
          txtACKno: "",
          txtIRN: "",
        },
        rows: [],
        rowsCount: 0,
        rowsOtherDetail: this.state.rowsOtherDetail,
        rowsOtherDetail1: this.state.rowsOtherDetail1,

        rowsCountOtherDetail: this.state.rowsOtherDetail.length,
        rowsCountOtherDetail1: this.state.rowsOtherDetail1.length,

        rowsPaymentMode: copyRowsAllCols(
          this.state.LedgerNameList,
          this.state.PaymentmodeListCols
        ),
        rowsCountPaymentMode: this.state.LedgerNameList.length,
        PaymentData: [],
      },
      () => {
        this.getDefaultProformaType();
        document.getElementById("dtpDate").focus();
        this.props.navigateTo("ChallanEntry");
      }
    );
  };

  updateStateInfo = (rows) => {
    let count = 0;
    rows.map((row) => {
      if (count === 0) {
        count++;
        this.setState({
          ARD: null,
          rows,
          rowsCount: rows.length,
          OrderselectionVisible: true,
        });
      }
    });
  };

  addActionColStatus = (rows) => {
    // console.log("rows disable edit", rows);
    const newRows = rows.map((row) => {
      const actionStatus = row.vac_orderitemno.length > 0 ? true : false;
      // console.log("row.vac_orderitemno", row.vac_orderitemno);
      return {
        ...row,
        DisableEdit: actionStatus,
      };
    });
    return newRows;
  };

  // DisableOnEditDelete = (vac_orderitemno) => {
  //   let DisableEdit = false;
  //   if (vac_orderitemno.length == 0) {
  //     DisableEdit = false;
  //   } else {
  //     DisableEdit = true;
  //   }
  //   return DisableEdit;
  // };

  OrderSelection = () => {
    if (this.validateChallan() === true) {
      // this.getLedgerName = () => {
      //   if (this.state.LedgerNameList && this.state.LedgerNameList[0]) {
      //     return this.state.LedgerNameList[0].vac_ledgername;
      //   } else {
      //     return "";
      //   }
      // };
      let ARD = null;
      this.setState({ ARD }, () => {
        ARD = (
          <AlertResponsiveDialog
            labelDisagree="Close"
            maxWidthClass={"1000px"}
            // alertTitle={'Sales Item Entry'}
            alertMessage={
              <OrderSelection
                SelectionFrom="Sales"
                Customer={this.state.formData.cmbCustomer}
                DRPname={
                  this.state.LedgerNameList && this.state.LedgerNameList[0]
                    ? this.state.LedgerNameList[0].vac_ledgername
                    : ""
                }
                bint_acyear={localStorage.getItem("ACY")}
                bint_acid={localStorage.getItem("acid")}
                cmbCompany={localStorage.getItem("CompanyName")}
                bint_salessrno={this.state.formData.edit_salessrno}
                dtpDate={this.state.formData.dtpDate}
                cmbOCPType={this.state.formData.cmbOCPType}
                txtOCPNo={this.state.formData.LblOCPNo}
                bint_billno={this.state.formData.txtOCPNo}
                cmbCustomer={this.state.formData.cmbCustomer}
                cmbShipTo={this.state.formData.cmbShipTo}
                cmbReference={this.state.formData.cmbReference}
                // CustomerStateCode={this.state.CustomerStateCode}
                // txtOtherDetail={this.state.formData.txtOtherDetail}
                txtDiscount={this.state.formData.txtDiscount}
                txtTaxable={this.state.formData.txtTaxable}
                txtCGST={this.state.formData.txtCGST}
                txtSGST={this.state.formData.txtSGST}
                txtIGST={this.state.formData.txtIGST}
                txtGrandTotal={this.state.formData.txtGrandTotal}
                txtTDSAmount={this.state.formData.txtTDSAmount}
                txtAdvPayment={this.state.formData.txtAdvPayment}
                txtRoundOff={this.state.formData.txtRoundOff}
                txtNetPayment={this.state.formData.txtNetPayment}
                txtRemark={this.state.formData.txtRemark}
                vac_receiptgenerated={
                  this.state.formData.chkReceiptGenerated ? "Yes" : "No"
                }
                vac_referencename={this.state.formData.cmbReference}
                bint_ci={localStorage.getItem("CI")}
                vac_username={localStorage.getItem("UserName")}
                onSuccessfulSelsSelection={this.updateStateInfo}
                refreshSalesItemList={this.refreshSalesItemList}
                resetAmount={this.resetAmount}
              />
            }
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD });
      });
    }
  };

  saveChallan = (
    bolinvoiceprint,
    copyInvoiceDetailsToClipBoard,
    bolewaybillprocess
  ) => {
    if (
      this.validateSales() &&
      this.validateChallanItemCount() &&
      this.validatePaymentModeAmount()
    ) {
      // this.props.toastErrorMsg("Second Alert")
      const dataLoadStatus = false;
      this.props.notifyProcessing();
      // this.props.toastErrorMsg("Third Alert");
      // console.log(
      //   "Number(this.state.formData.tblCGST)",
      //   Number(this.state.formData.tblCGST)
      // );
      // console.log(
      //   "this.state.formData.txtCGST + this.state.formData.tblCGST",
      //   Number(this.state.formData.txtCGST) +
      //     Number(this.state.formData.tblCGST)
      // );
      let rowsTotal = getRowColSum(this.state.rows, [
        "dec_cgstamt",
        "dec_sgstamt",
        "dec_igstamt",
      ]);
      /* dec_cgst:
            Number(this.state.formData.txtCGST) +
            Number(this.state.formData.tblCGST),
          dec_sgst:
            Number(this.state.formData.txtSGST) +
            Number(this.state.formData.tblSGST),
          dec_igst:
            Number(this.state.formData.txtIGST) +
            Number(this.state.formData.tblIGST), */
      this.setState({ dataLoadStatus }, () => {
        const reqData = {
          Op: "SaveSales_Item",
          bint_acyear: localStorage.getItem("ACY"),
          bolinvoiceprint: false,
          bint_acid: localStorage.getItem("acid"),
          vac_company: this.state.formData.cmbCompany,
          bint_salessrno: this.state.formData.edit_salessrno,
          dat_salesdate: this.state.formData.dtpDate,
          vac_billtype: this.state.formData.cmbOCPType,
          vac_billno: this.state.formData.LblOCPNo,
          bint_billno: this.state.formData.txtOCPNo,

          vac_customer: this.state.formData.cmbCustomer,
          vac_customershipto: this.state.formData.cmbShipTo,
          dec_discamt: this.state.formData.txtDiscount,
          dec_taxable: this.state.formData.txtTaxable,
          dec_cgst:
            Number(rowsTotal.dec_cgstamt) + Number(this.state.formData.tblCGST),
          dec_sgst:
            Number(rowsTotal.dec_sgstamt) + Number(this.state.formData.tblSGST),
          dec_igst:
            Number(rowsTotal.dec_igstamt) + Number(this.state.formData.tblIGST),
          dec_grtotal: this.state.formData.txtGrandTotal,
          dec_tdsamount: this.state.formData.txtTDSAmount,
          dec_advancepayment: this.state.formData.txtAdvPayment,
          dec_roundoff: this.state.formData.txtRoundOff,
          dec_netpayment: this.state.formData.txtNetPayment,
          bint_vouno: 0,
          vac_remark: this.state.formData.txtRemark,
          vac_receiptgenerated: this.state.formData.chkReceiptGenerated
            ? "Yes"
            : "No",
          PaymentData: this.getPaymentModeDataStatus()
            ? this.state.rowsPaymentMode
            : [],
          OtherDetailData:
            this.state.rowsOtherDetail & this.state.rowsOtherDetail1,
          bint_ci: localStorage.getItem("CI"),
          vac_username: localStorage.getItem("UserName"),
          vac_referencename: this.state.formData.cmbReference,
          dec_beforetaxamt: this.state.totalBeforeTaxAmt,
          dec_aftertaxamt: this.state.totalAfterTaxAmt,
        };
        fetchSales(reqData)
          .then((res) => {
            // console.log("reqData", reqData);
            this.props.updateProcessing(res.data.msgType, res.data.message);
            // console.log("res.data.msgType", res.data.msgType);
            if (res.data.msgType === "success") {
              let DefaultEntrySettingList = res.data.DefaultEntrySettingList,
                rowsOtherDetail = [],
                rowsOtherDetail1 = [],
                rowsCountOtherDetail = rowsOtherDetail.length,
                rowsCountOtherDetail1 = rowsOtherDetail1.length,
                rowsPaymentMode = [],
                rowsCountPaymentMode = rowsPaymentMode.length,
                InvoiceNoList = res.data.InvoiceNoList;
              if (
                res.data.LedgerNameList &&
                res.data.LedgerNameList.length > 0
              ) {
                rowsPaymentMode = res.data.LedgerNameList;
                rowsCountPaymentMode = rowsPaymentMode.length;
              }
              if (res.data.DetailList && res.data.DetailList.length > 0) {
                rowsOtherDetail = res.data.DetailList;
                rowsOtherDetail1 = res.data.DetailList;

                rowsCountOtherDetail = rowsOtherDetail.length;
                rowsCountOtherDetail1 = rowsOtherDetail1.length;
              }

              this.setState(
                {
                  dataLoadStatus: true,
                  BillNoList: InvoiceNoList,
                  DefaultEntrySettingList,

                  rowsOtherDetail,
                  rowsOtherDetail1,

                  rowsCountOtherDetail,
                  rowsCountOtherDetail1,
                  rowsPaymentMode,
                  rowsCountPaymentMode,
                },
                () => {
                  if (bolinvoiceprint) {
                    this.openInvoiceARDSelection();
                  }
                  /** Call copyInvoiceDetailsToClipBoard */
                  if (copyInvoiceDetailsToClipBoard) {
                    copyInvoiceDetailsToClipBoard();
                  }
                  if (bolewaybillprocess) {
                    this.ewaybillprocess();
                  }
                  this.clearInfo();
                }
              );
            }
          })
          .catch((error) => {
            console.log("Unknown error occurred in saveSales.", error);
          });
      });
    }
  };

  onDeleteBtnClick = () => {
    if (this.state.formData.edit_salessrno > 0) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={
              "Do you want to Delete Bill No. : " +
              this.state.formData.LblBillNo +
              " ?"
            }
            alertMessage=""
            handleOnClickYes={() => {
              return this.deleteSales(this.state.formData.edit_salessrno);
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD });
      });
    } else {
      this.props.toastErrorMsg("There are no sales to delete", "dtpDate");
    }
  };

  deleteSales = (edit_salessrno) => {
    if (edit_salessrno > 0) {
      this.props.notifyProcessing();
      this.setState({ dataLoadStatus: false }, () => {
        const reqData = {
          Op: "DeleteSales",
          bint_acyear: localStorage.getItem("ACY"),
          bint_acid: localStorage.getItem("acid"),
          edit_salessrno: edit_salessrno,
          dat_fromdate: "",
          dat_todate: "",
        };
        fetchSales(reqData)
          .then((res) => {
            this.props.updateProcessing(res.data.msgType, res.data.message);
            if (res.data.msgType === "success") {
              this.setState({ ARD: null, dataLoadStatus: true }, () => {
                this.clearInfo();
              });
            } else {
              this.setState({ dataLoadStatus: true });
            }
          })
          .catch((error) => {
            this.props.updateProcessing(
              "error",
              "Unknown error occurred in delete deleteSales. " + error
            );
          });
      });
    } else {
      this.props.notifyProcessing();
      this.props.updateProcessing(
        "error",
        "There are no sales records to delete."
      );
    }
  };

  onDeleteBtnClick = () => {};

  refreshSalesItemList = (rows, rowsCount) => {
    rows = this.addActionColStatus(rows);
    // console.log("rows", rows);
    this.setState(
      {
        rows,
        rowsCount,
      },
      () => {}
    );
  };

  resetAmount = (
    txtTaxable,
    txtCGST,
    txtSGST,
    txtIGST,
    txtGrandTotal,
    txtDiscount,
    edit_salessrno
  ) => {
    this.setState(
      {
        formData: {
          ...this.state.formData,
          txtTaxable,
          txtCGST,
          txtSGST,
          txtIGST,
          txtGrandTotal,
          txtDiscount,
          edit_salessrno,
        },
      },
      () => {
        // console.log("edit_salessrno", edit_salessrno);
        this.calNetAmount();
      }
    );
  };

  calNetAmount = () => {
    let txtNetPayment =
        Number(this.state.formData.txtGrandTotal) -
        Number(this.state.formData.txtTDSAmount) -
        Number(this.state.formData.txtAdvPayment) +
        Number(this.state.formData.txtRoundOff),
      txtRoundOff = 0;

    let arrNetPayment = getRoundOff(txtNetPayment);
    txtNetPayment = arrNetPayment["roff_number"];
    txtRoundOff = arrNetPayment["roff"].toFixed(2);
    // console.log("txtNetPayment", txtNetPayment);
    let chkReceiptGenerated = this.state.formData.chkReceiptGenerated;
    if (Number(this.state.formData.txtAdvPayment) === Number(0)) {
      chkReceiptGenerated = false;
    }
    this.setState(
      {
        formData: {
          ...this.state.formData,
          txtNetPayment,
          txtRoundOff,
          chkReceiptGenerated,
        },
      },
      () => {}
    );
  };

  generateChallanNo = () => {
    if (
      Number(this.state.formData.txtOCPNo) > 0 &&
      this.state.formData.SalesInvoiceGeneration != "Auto"
    ) {
      this.props.notifyProcessing();
      const reqData = {
        Op: "CreateStrBillNoFromType",
        bint_acyear: localStorage.getItem("ACY"),
        bint_acid: localStorage.getItem("acid"),
        int_invoiceno: Number(this.state.formData.txtOCPNo),
        vac_billtype: this.state.formData.cmbOCPType,
      };
      fetchSales(reqData)
        .then((res) => {
          this.props.updateProcessing("success", " No generated");
          this.setState({
            formData: {
              ...this.state.formData,
              LblOCPNo: res.data.InvoiceNo,
            },
          });
        })
        .catch((error) => {
          this.props.updateProcessing(
            "error",
            "Unknown error occurred in generateChallanNo. " + error
          );
        });
    } else {
      // this.props.toastErrorMsg("Enter  No", "txtBillNo");
    }
  };

  getProformaNo = () => {
    if (this.state.formData.cmbOCPType.length > 0) {
      // console.log("this.state.BillNoList", this.state.BillNoList);
      this.state.BillNoList.map((row) => {
        if (row.vac_invoicetype === this.state.formData.cmbOCPType) {
          // console.log("row.vac_invoicetype", row.vac_invoicetype);
          // console.log("row.int_invoiceno", row.int_invoiceno);
          // console.log("row.vac_invoiceno", row.vac_invoiceno);
          this.setState(
            {
              formData: {
                ...this.state.formData,
                txtOCPNo: row.int_invoiceno,
                LblOCPNo: row.vac_invoiceno,
              },
            },
            () => {}
          );
        }
      });
    }
  };

  getStateCodeOFCustomer = () => {
    if (
      this.state.formData.cmbCustomer.length > 0 &&
      this.state.autoResetFormData === true
    ) {
      this.state.Customer.map((row) => {
        if (row.vac_customer === this.state.formData.cmbCustomer) {
          this.setState({
            formData: {
              ...this.state.formData,
              cmbReference:
                row.vac_referencename != null ? row.vac_referencename : "",
            },
            CustomerStateCode: row.vac_statecode,
            CustomerData: row,
          });
        }
      });
    } else if (this.state.autoResetFormData === false) {
      this.setState({ autoResetFormData: true });
    }
  };

  getDefaultProformaType = () => {
    if (this.state.BillNoList && this.state.BillNoList.length > 0) {
      this.state.BillNoList.map((row) => {
        if (row.int_default === 1 || row.int_default === "1") {
          this.setState(
            {
              formData: {
                ...this.state.formData,
                cmbOCPType: row.vac_invoicetype,
              },
            },
            () => {
              this.getProformaNo();
            }
          );
        }
      });
    }
  };

  getCustomerList = () => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "LoadCustomerDetails",
      bint_acid: localStorage.getItem("acid"),
    };
    fetchCustomerMaster(reqData)
      .then((res) => {
        this.props.updateProcessing("success", "Customer List Loaded");
        let Customer = res.data.CustomerList,
          ShipTo = res.data.CustomerList;
        this.setState(
          {
            Customer,
            ShipTo,
          },
          () => {
            // console.log("this.state", this.state);
          }
        );
      })
      .catch((error) => {
        console.log("Unknown error occurred in getCustomerList.", error);
      });
  };

  getReferenceList = () => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "LoadReference",
      bint_acid: localStorage.getItem("acid"),
    };
    fetchReferenceMaster(reqData)
      .then((res) => {
        this.props.updateProcessing("success", "Customer List Loaded");
        let ReferenceList = res.data.ReferenceList;
        this.setState(
          {
            ReferenceList,
          },
          () => {
            // console.log("this.state", this.state);
          }
        );
      })
      .catch((error) => {
        console.log("Unknown error occurred in getCustomerList.", error);
      });
  };

  getDetailList = () => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "DetailList",
      bint_acid: localStorage.getItem("acid"),
      vac_detailtype: "",
    };
    fetchDetailMaster(reqData)
      .then((res) => {
        this.props.updateProcessing("success", "Detial List Loaded");
        let rowsOtherDetail = res.data.DetailList,
          rowsOtherDetail1 = res.data.DetailList,
          rowsCountOtherDetail = 0,
          rowsCountOtherDetail1 = 0;

        this.setState(
          {
            rowsOtherDetail,
            rowsOtherDetail1,
            rowsCountOtherDetail,

            rowsCountOtherDetail1,
          },
          () => {
            // console.log("this.state", this.state);
          }
        );
      })
      .catch((error) => {
        console.log("Unknown error occurred in getDetailList.", error);
      });
  };

  onAddClickCustomer = () => {
    this.setState({ ARD: null }, () => {
      let ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          alertMessage=<CustomerMaster />
          defaultOpenDialog={true}
          handleOnClickNo={this.getCustomerList}
        />
      );
      this.setState({ ARD });
    });
  };

  onAddClickReference = () => {
    this.setState({ ARD: null }, () => {
      let ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          alertMessage=<ReferenceMaster />
          defaultOpenDialog={true}
          handleOnClickNo={this.getReferenceList}
        />
      );
      this.setState({ ARD });
    });
  };

  openInvoiceARDSelection = () => {
    let vac_billno = Array(this.state.formData.LblOCPNo);
    this.setState({ ARD: null }, () => {
      let ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          alertMessage=<SalesInvoiceSelection
            bint_acid={localStorage.getItem("acid")}
            bint_acyear={localStorage.getItem("ACY")}
            vac_billno={vac_billno}
          />
          defaultOpenDialog={true}
        />
      );
      this.setState({ ARD });
    });
  };

  getItemList = () => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "ItemList",
      bint_acid: localStorage.getItem("acid"),
    };
    fetchItemMaster(reqData)
      .then((res) => {
        this.props.updateProcessing("success", "Item List Loaded");
        let ItemNameList = res.data.ItemList;
        this.setState(
          {
            ItemNameList,
          },
          () => {
            // console.log("this.state", this.state);
          }
        );
      })
      .catch((error) => {
        console.log("Unknown error occurred in getItemList.", error);
      });
  };

  setSaveBtnDisplay = () => {
    let isParamFound =
      this.props.params &&
      this.props.params.EditSalesSrNo &&
      this.props.params.EditSalesSrNo.substring(1).length > 0;
    if (isParamFound !== true) {
      isParamFound = false;
    }
    let paramEditSalesSrNo = 0;
    if (isParamFound) {
      var editInfo = this.props.params.EditSalesSrNo.split(":");
      paramEditSalesSrNo = Number(editInfo[2]);
      if (paramEditSalesSrNo <= 0) {
        isParamFound = false;
      }
    }
    // console.log("this.props.userPrivilege.Sales", this.props.userPrivilege.Sales, this.props.userPrivilege.Sales == 'W');
    // console.log("Number(this.state.formData.edit_salessrno)", Number(this.state.formData.edit_salessrno), Number(this.state.formData.edit_salessrno) <= Number(0));
    // console.log("isParamFound", isParamFound, isParamFound === false);
    if (this.props.userPrivilege.Sales == "M") {
      return "block";
    } else if (this.props.userPrivilege.Sales == "R") {
      return "none";
    } else if (
      (this.props.userPrivilege.Sales == "W" &&
        Number(this.state.formData.edit_salessrno) > Number(0) &&
        isParamFound === false) ||
      (this.props.userPrivilege.Sales == "W" &&
        Number(this.state.formData.edit_salessrno) > Number(0) &&
        isParamFound === true &&
        Number(this.state.formData.edit_salessrno) !==
          Number(paramEditSalesSrNo)) ||
      (this.props.userPrivilege.Sales == "W" &&
        Number(this.state.formData.edit_salessrno) <= Number(0))
    ) {
      return "block";
    } else {
      return "none";
    }
  };

  setPaymentData = (rowsPaymentMode) => {
    this.setState(
      {
        rowsPaymentMode,
      },
      () => {
        // console.log("this.state.rows", this.state.rows);
      }
    );
  };

  getDefaultEntrySettingRow = () => {
    let DefaultEntrySettingList = [];
    if (
      this.state.DefaultEntrySettingList &&
      this.state.DefaultEntrySettingList.length > 0
    ) {
      if (
        this.state.DefaultEntrySettingList[0].vac_transacationtype == "Paid"
      ) {
        DefaultEntrySettingList = this.state.DefaultEntrySettingList[0];
      } else {
        if (
          this.state.DefaultEntrySettingList[1].vac_transacationtype == "Paid"
        ) {
          DefaultEntrySettingList = this.state.DefaultEntrySettingList[1];
        }
      }
    }
    return DefaultEntrySettingList;
  };

  handleInvoice = () => {
    // const salesInfo = {
    //   bint_acid: localStorage.getItem("acid"),
    //   bint_acyear: localStorage.getItem("ACY"),
    //   vac_billno: this.state.formData.LblBillNo,
    //   edit_salessrno: this.state.formData.edit_salessrno,
    //   vac_userid: localStorage.getItem("UserID"),
    //   bint_ci: localStorage.getItem("CI"),
    // };

    // const jsonString = JSON.stringify({ salesInfo });
    // console.log("jsonString", jsonString);
    // navigator.clipboard
    //   .writeText('"RTW" ' + jsonString)
    // .then(() => {
    this.trimFormData(() => {
      this.saveChallan(false, () => {
        const salesInfo = {
          bint_acid: localStorage.getItem("acid"),
          bint_acyear: localStorage.getItem("ACY"),
          vac_billno: this.state.formData.LblOCPNo,
          edit_salessrno: this.state.formData.edit_salessrno,
          vac_userid: localStorage.getItem("logInID"),
          bint_ci: localStorage.getItem("CI"),
        };

        const jsonString = JSON.stringify({ salesInfo });
        // console.log("jsonString", jsonString);
        navigator.clipboard.writeText('"RTW" ' + jsonString);
      });
    });
    // })
    // .catch((error) => {
    //   console.error("Error copying to clipboard:", error);
    // });
  };
  // getPaymentModeDataStatus = () => {
  //   let result = false;
  //   if (
  //     this.state.transactionType == " Paid"
  //     // this.getPayRemarkLblVisibleStatus()
  //   ) {
  //     /*  if (
  //       this.state.transactionType == " Advance"
  //       // this.getPayRemarkLblVisibleStatus()
  //     )  */ result = true;
  //   } else {
  //     this.state.rowsPaymentMode.map((row) => {
  //       row.dec_amount = "";
  //       row.vac_chequeno = "";
  //       row.vac_referenceno = "";
  //       row.dat_transactiondate = "";
  //       row.vac_remark = "";
  //     });
  //   }
  //   return result;
  // };
  // setSaveBtnDisplay = () => {
  //   let isParamFound =
  //     this.props.params &&
  //     this.props.params.EditPurchaseSrNo &&
  //     this.props.params.EditPurchaseSrNo.substring(1).length > 0;
  //   if (isParamFound !== true) {
  //     isParamFound = false;
  //   }
  //   let paramEditPurchaseSrNo = 0;
  //   if (isParamFound) {
  //     var editInfo = this.props.params.EditPurchaseSrNo.split(":");
  //     paramEditPurchaseSrNo = Number(editInfo[2]);
  //     if (paramEditPurchaseSrNo <= 0) {
  //       isParamFound = false;
  //     }
  //   }
  //   if (this.props.userPrivilege.Purchase == "M") {
  //     return "block";
  //   } else if (this.props.userPrivilege.Purchase == "R") {
  //     return "none";
  //   } else if (
  //     (this.props.userPrivilege.Purchase == "W" &&
  //       Number(this.state.formData.edit_purchasesrno) > Number(0) &&
  //       isParamFound === false) ||
  //     (this.props.userPrivilege.Purchase == "W" &&
  //       Number(this.state.formData.edit_purchasesrno) > Number(0) &&
  //       isParamFound === true &&
  //       Number(this.state.formData.edit_purchasesrno) !==
  //         Number(paramEditPurchaseSrNo)) ||
  //     (this.props.userPrivilege.Purchase == "W" &&
  //       Number(this.state.formData.edit_purchasesrno) <= Number(0))
  //   ) {
  //     return "block";
  //   } else {
  //     return "none";
  //   }
  // };
  // getDefaultEntrySettingRow = () => {
  //   let DefaultEntrySettingList = [];
  //   if (
  //     this.state.DefaultEntrySettingList &&
  //     this.state.DefaultEntrySettingList.length > 0
  //   ) {
  //     if (
  //       this.state.DefaultEntrySettingList[0].vac_transacationtype == "Paid"
  //     ) {
  //       DefaultEntrySettingList = this.state.DefaultEntrySettingList[0];
  //     } else {
  //       if (
  //         this.state.DefaultEntrySettingList[1].vac_transacationtype == "Paid"
  //       ) {
  //         DefaultEntrySettingList = this.state.DefaultEntrySettingList[1];
  //       }
  //     }
  //   }
  //   return DefaultEntrySettingList;
  // };
  // setPaymentData = (rowsPaymentMode) => {
  //   this.setState(
  //     {
  //       rowsPaymentMode,
  //     },
  //     () => {
  //       // console.log("this.state.rows", this.state.rows);
  //     }
  //   );
  // };
  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
    // this.togglePaymentModeInfo(); // Set anchor element to the clicked target
  };

  handleClose = () => {
    this.setState({ anchorEl: null }); // Close the menu
  };

  handleSelectTransactionType = (type) => {
    this.setState({ transactionType: type });
    if (type === " Paid") {
      this.openTransactionType();

      this.getPaymentModeDataStatus();
    }
    // if (type === " Advance") {
    //   this.getPaymentModeDataStatus();
    //   this.openTransactionType();
    // }
    // Update transaction type
    this.handleClose(); // Close the menu
  };

  openTransactionType = () => {
    let ARD = null;
    const { PaymentData, rowsPaymentMode } = this.state;
    let DefaultEntrySettingList = this.getDefaultEntrySettingRow();

    const txtAmount4PaymentModeTable =
      Number(this.state.formData.txtAdvPayment) ||
      Number(this.state.formData.txtNetPayment);

    this.setState({ ARD }, () => {
      ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          alertMessage={
            <PaymentModeTable
              DefaultEntrySettingList={DefaultEntrySettingList}
              PaymentData={PaymentData}
              PaymentLedgerNameList={rowsPaymentMode}
              Edit_SrNo={this.state.formData.edit_purchasesrno}
              setPaymentData={this.setPaymentData}
              txtAmount={txtAmount4PaymentModeTable}
            />
          }
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
          handleOnClickNo={() => {
            this.calAdvAmount(); // Call the calculation method
          }}
        />
      );
      this.setState({ ARD });
      console.log("rowsPaymentMode:", this.state.rowsPaymentMode);
    });
  };
  getPaymentModeInfoAsText = () => {
    const { rowsPaymentMode } = this.state;

    if (rowsPaymentMode.length === 0) {
      return "No payment mode information available.";
    }

    return rowsPaymentMode
      .map((row, index) => {
        return `Payment Mode ${index + 1}: 
        Ledger Name: ${row.vac_ledgername || "N/A"}, 
        Amount: ${row.dec_amount || "0"}, 
        Cheque No: ${row.vac_chequeno || "N/A"}, 
        Reference No: ${row.vac_referenceno || "N/A"}, 
        Transaction Date: ${row.dat_transactiondate || "N/A"}, 
        Remark: ${row.vac_remark || "N/A"}`;
      })
      .join("\n");
  };
  refreshPaymentList = (rows, rowsCount) => {
    this.setState({
      rows,
      rowsCount,
    });
  };

  //#endregion Function

  render() {
    const { SupplierList, totals } = this.state;
    const isDisplaySaveBtn = this.setSaveBtnDisplay();
    let rowsTotal = getRowColSum(this.state.rows, [
      "dec_cgstamt",
      "dec_sgstamt",
      "dec_igstamt",
    ]);
    const rows = this.state.searchOpen
      ? this.state.searchRows
      : this.state.rows;
    // console.log("rows", rows);
    const rowsCount = this.state.searchOpen
      ? this.state.searchRowsCount
      : this.state.rowsCount;
    let CGST =
      Number(this.state.formData.txtCGST) != 0
        ? Number(this.state.formData.txtCGST)
        : Number(rowsTotal.dec_cgstamt) + Number(this.state.formData.tblCGST);
    let SGST =
      Number(this.state.formData.txtSGST) != 0
        ? Number(this.state.formData.txtSGST)
        : Number(rowsTotal.dec_sgstamt) + Number(this.state.formData.tblSGST);
    let IGST =
      Number(this.state.formData.txtIGST) != 0
        ? Number(this.state.formData.txtIGST)
        : Number(rowsTotal.dec_igstamt) + Number(this.state.formData.tblIGST);
    let txtGrandTotal =
      Number(this.state.formData.txtTaxable) +
      Number(this.state.totalBeforeTaxAmt) +
      CGST +
      SGST +
      IGST +
      Number(this.state.totalAfterTaxAmt);
    txtGrandTotal = txtGrandTotal.toFixed(2);

    let NetPayment =
      Number(txtGrandTotal) -
      Number(this.state.formData.txtTDSAmount) -
      Number(this.state.formData.txtAdvPayment);

    let arrNetPayment = getRoundOff(NetPayment);
    NetPayment = arrNetPayment["roff_number"];
    let txtRoundOff = arrNetPayment["roff"];
    let { module } = this.props;

    return (
      <Box>
        <Grid container direction="row" gap={2}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            className="title"
          >
            <label
              htmlFor="Title"
              style={{ fontSize: "30px", color: "#515151" }}
            >
              <b>{module + " Entry"}</b>
            </label>
          </Grid>
          <Grid
            container
            direction="row"
            justifyContent="space-evenly"
            alignItems="flex-start"
            spacing={2}
            marginTop={0}
          >
            <Grid item sm={12} lg={6}>
              <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                spacing={2}
                marginTop={0}
              >
                <Grid item>
                  <CtDtp
                    id="dtpDate"
                    label="Date*"
                    width="150"
                    handleOnChange={this.handleOnChange}
                    defaultValue={this.state.formData.dtpDate}
                    value={this.state.formData.dtpDate}
                    onKeyDown={this.props.onKeyDown}
                    accountYear={localStorage.getItem("ACY")}
                  />
                </Grid>
                <Grid item>
                  <CtCmb
                    id="cmbOCPType"
                    label={this.props.Type + " Type*"}
                    value={this.state.formData.cmbOCPType}
                    handleOnChange={this.handleOnChange}
                    items={this.state.BillNoList}
                    width={120}
                    maxLength={20}
                    colID="vac_invoicetype"
                    onKeyDown={this.props.onKeyDown}
                  />
                </Grid>
                <Grid
                  item
                  display={
                    this.state.SalesInvoiceGeneration == "Manually"
                      ? "block"
                      : "none"
                  }
                >
                  <CtTxtNum
                    id="txtOCPNo"
                    label={this.props.No + " No*"}
                    // disabled={true}
                    value={this.state.formData.txtOCPNo}
                    handleOnChange={this.handleOnChange}
                    width={80}
                    maxLength={10}
                    onKeyDown={this.props.onKeyDown}
                  />
                </Grid>
                <Grid
                  item
                  display={
                    this.state.SalesInvoiceGeneration == "Manually"
                      ? "block"
                      : "none"
                  }
                >
                  <CtBtn
                    label={<RefreshOutlined />}
                    onClick={this.generateChallanNo}
                  />
                </Grid>
                <Grid item>
                  <label>{this.state.formData.LblOCPNo}</label>
                </Grid>
              </Grid>

              <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                spacing={2}
                marginTop={0}
              >
                <Grid item>
                  <CtCmbEditable
                    id="cmbCustomer"
                    label="Customer*"
                    items={this.state.Customer}
                    value={this.state.formData.cmbCustomer}
                    handleOnChange={this.handleOnChange}
                    width={250}
                    maxLength={100}
                    colID="vac_customer"
                    bolVisibleOnAddClickIcon={
                      this.props.userPrivilege.Customer == "A" ? true : false
                    }
                    onAddClick={this.onAddClickCustomer}
                    onKeyDown={this.props.onKeyDown}
                    nextCtrlID="cmbShipTo"
                  />
                </Grid>
                <Grid
                  item
                  display={this.state.Displaybtn === true ? "block" : "none"}
                >
                  <CtBtn
                    label="Order Selection"
                    onClick={this.OrderSelection}
                  />
                </Grid>
              </Grid>

              <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                spacing={2}
                marginTop={0}
              >
                <Grid item>
                  <CtCmbEditable
                    id="cmbShipTo"
                    label="Ship To"
                    items={this.state.ShipTo}
                    value={this.state.formData.cmbShipTo}
                    handleOnChange={this.handleOnChange}
                    width={250}
                    maxLength={100}
                    colID="vac_customer"
                    bolVisibleOnAddClickIcon={
                      this.props.userPrivilege.Customer == "A" ? true : false
                    }
                    onAddClick={this.onAddClickCustomer}
                    onKeyDown={this.props.onKeyDown}
                    nextCtrlID="cmbReference"
                  />
                </Grid>
                <Grid item>
                  <CtCmbEditable
                    id="cmbReference"
                    label="Reference"
                    items={this.state.ReferenceList}
                    value={this.state.formData.cmbReference}
                    handleOnChange={this.handleOnChange}
                    width={250}
                    maxLength={100}
                    colID="vac_referencename"
                    bolVisibleOnAddClickIcon={
                      this.props.userPrivilege.Reference &&
                      this.props.userPrivilege.Reference == "A"
                        ? true
                        : false
                    }
                    onAddClick={this.onAddClickReference}
                    onKeyDown={this.props.onKeyDown}
                    nextCtrlID="txtDiscountAmount"
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item sm={12} lg={6}>
              <Grid
                container
                direction="column"
                justifyContent="flex-start"
                alignItems="flex-start"
                spacing={2}
                marginTop={0}
              >
                <Grid item>
                  {this.state.formData.cmbCustomer.length > 0 ? (
                    <TableList
                      columns={this.state.columnsOtherDetail}
                      counter={this.state.counter}
                      rows={this.state.rowsOtherDetail.filter(
                        (row) => row.vac_calculation === ""
                      )}
                      rowsCount={this.state.rowsCountOtherDetail}
                      rowsPerPage={this.state.rowsPerPageOtherDetail}
                      handleChangeRowsPerPage={
                        this.handleChangeRowsPerPageOtherDetail
                      }
                      handleOnRowDataChange={
                        this.handleOnRowDataChangeOtherDetail
                      }
                    />
                  ) : (
                    ""
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item display={isDisplaySaveBtn}>
          <Button
            variant="outlined"
            color="primary"
            style={{
              position: "fixed",
              top: "100px",
              right: "20px",
              zIndex: 1000,
              backgroundColor: "white",
              // Increase z-index to make sure it's above everything
              // : "red",
            }}
            onClick={() => {
              this.savePurchase();
            }}
          >
            Save
          </Button>
        </Grid>

        <Grid item marginTop={3} className="maintable">
          <TableContainer component={Paper}>
            <TableList
              columns={this.state.columns}
              counter={this.state.counter}
              rows={rows}
              rowsCount={rowsCount}
              rowsPerPage={this.state.rowsPerPage}
              handleChangeRowsPerPage={this.handleChangeRowsPerPage}
              handleOnActionClick={this.handleARDonActionClick}
              actionList={this.state.actionList}
              keyColumn={this.state.keyColumn}
              handleOnSearchChange={this.handleOnSearchChange}
              searchColumns={this.state.searchColumns}
              searchData={this.state.searchData}
              provideSearch={true}
              handleOnNewEntryClick={() => {
                this.trimFormData(this.handleOnNewEntryClick);
              }}
            />
          </TableContainer>
        </Grid>
        <FormControl fullWidth>
          <Box display="flex" justifyContent="space-between" marginTop={2}>
            <Box flex={2} marginX={20}>
              <Grid item sm={12} lg={6}>
                <Grid
                  container
                  direction="column"
                  justifyContent="flex-start"
                  alignItems="flex-start"
                  spacing={2}
                  marginTop={0}
                >
                  <Grid item>
                    {this.state.formData.cmbCustomer.length > 0 ? (
                      <TableList
                        columns={this.state.columnsOtherDetail}
                        counter={this.state.counter}
                        rows={this.state.rowsOtherDetail1.filter(
                          (row) => row.vac_calculation !== ""
                        )}
                        rowsCount={this.state.rowsCountOtherDetail1}
                        rowsPerPage={this.state.rowsPerPageOtherDetail1}
                        handleChangeRowsPerPage={
                          this.handleChangeRowsPerPageOtherDetail1
                        }
                        handleOnRowDataChange={
                          this.handleOnRowDataChangeOtherDetail1
                        }
                      />
                    ) : (
                      ""
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="flex-end"
              position="sticky"
              top={0}
            >
              {/* <h4 style={{ margin: 5 }}>
                Total Basic Amount: {this.state.totalBeforeTaxAmt}
              </h4> */}
              <h4 style={{ margin: 5 }}>
                Total Discount: {this.state.formData.txtDiscount}
              </h4>
              <h4 style={{ margin: 5 }}>
                Total Taxable Amount: {this.state.formData.txtTaxable}
              </h4>
              <h4 style={{ margin: 5 }}>
                Before Tax Amount: {this.state.totalBeforeTaxAmt}
              </h4>

              <h4 style={{ margin: 5 }}>Total CGST: {CGST}</h4>
              <h4 style={{ margin: 5 }}>Total SGST: {SGST}</h4>
              <h4 style={{ margin: 5 }}>Total IGST: {SGST}</h4>

              <h4 style={{ margin: 5 }}>
                After Tax Amount: {this.state.totalAfterTaxAmt}
              </h4>

              <h4 style={{ margin: 5 }}>RoundOff: {txtRoundOff}</h4>

              <h4 style={{ margin: 5 }}>Grand Total: {txtGrandTotal}</h4>
              <CtTxt
                id="txtTDSAmount"
                label="TDS Amount"
                handleOnChange={this.handleOnChange}
                value={this.state.formData.txtTDSAmount}
                width={110}
                maxLength={10}
                textAlign="right"
                onKeyDown={this.props.onKeyDown}
                nextCtrlID="txtAdvPayment"
              />
              <Box display="flex" justifyContent="flex-end" gap={3}>
                <CtTxtAmt
                  id="txtAdvPayment"
                  label="Adv Payment"
                  // disabled={true}
                  value={this.state.formData.txtAdvPayment}
                  handleOnChange={this.handleOnChange}
                  width={110}
                  textAlign="right"
                  maxLength={10}
                  onKeyDown={this.props.onKeyDown}
                />
                {/* <h4 style={{ margin: 5 }}>
                  Adv Payment:
                  {this.state.formData.txtAdvPayment}
                </h4> */}
              </Box>
              <h4 style={{ margin: 5 }}>Net Payment: {NetPayment}</h4>
            </Box>
          </Box>
        </FormControl>
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </Box>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps
)(HOCVerifyIsUser(HoCtToastContainer(withRouter(OCPEntry))));
